<div [ngClass]="{ 'container-fluid': noRedirection, 'bg-white': noRedirection, 'tab-content-border': noRedirection }">
  <div class="container pt-4 pb-5" [ngClass]="{ 'container-shadow': !noRedirection, 'my-4': !noRedirection, 'mb-4': noRedirection }">
    <div class="text-center py-3" *ngIf="loading">
      <i class="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
    <h3>New Email Share</h3>
    <div class="row">
      <div class="col-sm-12">
        <div class="row" *ngIf="!loading">
          <div class="col-md-12">
            <div class="form-row">
              <div class="col-sm-12 mb-4" *ngIf="toUsers && toUsers.length > 0">
                <app-multi-select-search
                  label="To"
                  [searchOptions]="toUsers || []"
                  [selectedOptions]="to || []"
                  (selected)="to = $event">
                </app-multi-select-search>
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-12 mb-4" *ngIf="ccUsers && ccUsers.length > 0">
                <app-multi-select-search
                  label="CC"
                  [searchOptions]="ccUsers || []"
                  [selectedOptions]="cc || []"
                  (selected)="cc = $event">
                </app-multi-select-search>
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-12 mb-4" *ngIf="bccUsers && bccUsers.length > 0">
                <app-multi-select-search
                  label="BCC"
                  [searchOptions]="bccUsers || []"
                  [selectedOptions]="bcc || []"
                  (selected)="bcc = $event">
                </app-multi-select-search>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <label for="email-subject">Subject:</label>
                <input type="text" class="form-control" id="email-subject" name='email_subject' ngDefaultControl [(ngModel)]="emailSub" />
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <label for="email-body">Body:</label>
                <textarea class="form-control" id="email-body" name='email_body' ngDefaultcontrol rows="3" [(ngModel)]="emailBod"></textarea>
              </div>
            </div>
            <div class="form-group pt-2">
              <button type="button" class="btn btn-primary" (click)="makeEmailShare()" [disabled]="formSubmitting">
                {{ formSubmitting ? 'Sending Email' : 'Send Email' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
              >&nbsp;
              <button type="button" class="btn btn-outline-secondary" (click)="cancelEmailShare()" *ngIf="!noRedirection">Cancel</button>
              <button type="button" class="btn btn-outline-secondary" (click)="reset()" *ngIf="noRedirection">Reset</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
